// extracted by mini-css-extract-plugin
export default {"text":"MainHeader_text__pCDuP","img":"MainHeader_img__Rfvvj","column":"MainHeader_column__DSZja","container":"MainHeader_container__17pn5"};